/**
 * Removes properties with null, undefined, or empty string values from a filters object.
 * Returns a new object without mutating the original.
 * @param filters - The filters object to sanitize
 * @returns A new object containing only properties with valid (non-null, non-undefined, non-empty) values
 */
export function sanitizeFilters<T extends Record<string, unknown>>(
  filters: T | null | undefined
): Partial<T> {
  if (!filters) {
    return {};
  }

  const sanitized: Partial<T> = {};

  for (const key of Object.keys(filters) as Array<keyof T>) {
    const value = filters[key];

    if (value !== null && value !== undefined && value !== '') {
      sanitized[key] = value;
    }
  }

  return sanitized;
}
